import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=60a42660&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.scss?vue&type=style&index=0&id=60a42660&prod&lang=scss&scoped=true&"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=60a42660&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a42660",
  null
  
)

export default component.exports